import { Directive, ElementRef, EventEmitter, OnInit, Output } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonService } from '../services/common/common.service';

declare const google: any;

@Directive({
  selector: '[appAddress]'
})
export class AddressDirective implements OnInit {

  @Output() addressSelect: EventEmitter<any> = new EventEmitter();
  private element: HTMLInputElement;
  constructor(
    private el: ElementRef,
    private commonService: CommonService,
    private ngxUiLoaderService: NgxUiLoaderService
  ) {
    this.element = el.nativeElement;
  }

  async getGeo(place: any) {
    const { address_components, geometry, name } = place;
    const geo = [geometry.location.lng(), geometry.location.lat()];
    const line2 = address_components.find((x: any) => x.types.includes('locality'));
    const country = address_components.find((x: any) => x.types.includes('country'));
    const postalCode = address_components.find((x: any) => x.types.includes('postal_code'));
    const state = address_components.find((x: any) => x.types.includes('administrative_area_level_1'));
    const district = address_components.find((x: any) => x.types.includes('administrative_area_level_2'));

    this.ngxUiLoaderService.start();
    const [line1Hindi, line2Hindi, stateHindi, districtHindi] = await Promise.all([
      this.translateFunc(name),
      this.translateFunc(line2?.long_name),
      this.translateFunc(state?.long_name),
      this.translateFunc(district?.long_name)
    ]);

    this.ngxUiLoaderService.stop();

    const addressObj = {
      line1: {
        en: name,
        hi: line1Hindi
      },
      line2: {
        en: line2?.long_name,
        hi: line2Hindi
      },
      state: {
        en: state?.long_name,
        hi: stateHindi
      },
      district: {
        en: district?.long_name,
        hi: districtHindi
      },
      block: {
        en: '',
        hi: ''
      },
      zipcode: postalCode?.long_name || '',
      geo
    };
    return addressObj;
  }

  ngOnInit(): void {
    const options = {
      types: ['geocode'],  // or '(cities)' if that's what you want?
      componentRestrictions: { country: 'ind' }
    };
    const autocomplete = new google.maps.places.Autocomplete(this.el.nativeElement, options);
    google.maps.event.addListener(autocomplete, 'place_changed', async () => {
      this.addressSelect.emit(await this.getGeo(autocomplete.getPlace()));
    });
  }

  translateFunc(data: any) {
    return new Promise((resolve, reject) => {
      this.commonService
        .translate(data)
        .then(resolve)
        .catch(reject);
    });
  }

  formatData(dataArray: Array<any>, name: string) {
    return new Promise((resolve, reject) => {
      let bool = false;
      for (let i = 0; i < dataArray.length; i++) {
        if (dataArray[i].types.includes(name)) {
          bool = true;
          resolve(dataArray[i].long_name);
          break;
        }
        if (i === dataArray.length - 1 && !bool) {
          resolve('');
          break;
        }
      }
    });
  }

}
